import { Dialog } from "@headlessui/react";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ModalFoterBox, ModalHeaderBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { ConstMessage } from "../../config/const";

export const NotEditableModal = ({
  open,
  toggle,
  closeOnClickOutside
}: ModalProp) => {  
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-sm ">
          <form>
            <div className="px-2 pb-4 sm:p-4">
              <div className="text-left sm:mt-3">
                <ModalHeaderBox
                  title={"編集できません"}
                />
                  <div className="text-left pl-5 mt-3 ">
                    {ConstMessage.ERR_INVALID_GROUP}
                  </div>
              </div>
            </div>

            <ModalFoterBox>
              <Button
                className="mx-2 mt-1"
                onClick={toggle}
                children={"OK"}
              />
            </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  );
};